module.exports = __webpack_public_path__ + "static/media/matei-zaharia.9925a7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/matei-zaharia.png
// module id = 289
// module chunks = 0